export interface IState {
  positionData: any;
  woTypeData: any;
  haulLocations: any;
  storageLocation: any;
  internalJobCode: any;
  skuCategoryData: any;
  BoatItemCategoryData: any;
  DinghyMakeData: any;
  ShippingCompanyData: any;
}

type Action = any;

export const StaticDataReducer = (
  state: IState = {
    positionData: [],
    woTypeData: [],
    haulLocations: [],
    storageLocation: [],
    internalJobCode: [],
    skuCategoryData: [],
    BoatItemCategoryData: [],
    DinghyMakeData: [],
    ShippingCompanyData: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_POSITIONS_STATIC_DATA":
      return {
        ...state,
        positionData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.positionData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_STATIC_DATA":
      return {
        ...state,
        positionData: state?.positionData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_POSITION":
      return {
        ...state,
        positionData: state?.positionData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_POSITION":
      return {
        ...state,
        positionData: state?.positionData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_WO_TYPE_STATIC_DATA":
      return {
        ...state,
        woTypeData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.woTypeData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_WO_TYPE":
      return {
        ...state,
        woTypeData: state?.woTypeData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_WO_TYPE":
      return {
        ...state,
        woTypeData: state?.woTypeData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_WO_TYPE":
      return {
        ...state,
        woTypeData: state?.woTypeData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_HAUL_LOCATION_STATIC_DATA":
      return {
        ...state,
        haulLocations:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.haulLocations, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_HAUL_LOCATION":
      return {
        ...state,
        haulLocations: state?.haulLocations?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_HAUL_LOCATION":
      return {
        ...state,
        haulLocations: state?.haulLocations?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_HAUL_LOCATION":
      return {
        ...state,
        haulLocations: state?.haulLocations?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_STORAGE_LOCATION_STATIC_DATA":
      return {
        ...state,
        storageLocation:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.storageLocation, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_STORAGE_LOCATION":
      return {
        ...state,
        storageLocation: state?.storageLocation?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_STORAGE_LOCATION":
      return {
        ...state,
        storageLocation: state?.storageLocation?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_STORAGE_LOCATION":
      return {
        ...state,
        storageLocation: state?.storageLocation?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_INTERNAL_JOB_CODE_STATIC_DATA":
      return {
        ...state,
        internalJobCode:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.internalJobCode, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_INTERNAL_JOB_CODE":
      return {
        ...state,
        internalJobCode: state?.internalJobCode?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_INTERNAL_JOB_CODE":
      return {
        ...state,
        internalJobCode: state?.internalJobCode?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_INTERNAL_JOB_CODE":
      return {
        ...state,
        internalJobCode: state?.internalJobCode?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_SKU_CATEGORY_STATIC_DATA":
      return {
        ...state,
        skuCategoryData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.skuCategoryData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_SKU_CATEGORY":
      return {
        ...state,
        skuCategoryData: state?.skuCategoryData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_SKU_CATEGORY":
      return {
        ...state,
        skuCategoryData: state?.skuCategoryData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_SKU_CATEGORY":
      return {
        ...state,
        skuCategoryData: state?.skuCategoryData?.filter((elem: any) => elem?._id !== action?.payload),
      };
    case "GET_BOAT_ITEM_CATEGORY_STATIC_DATA":
      return {
        ...state,
        BoatItemCategoryData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.BoatItemCategoryData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_BOAT_ITEM_CATEGORY":
      return {
        ...state,
        BoatItemCategoryData: state?.BoatItemCategoryData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_BOAT_ITEM_CATEGORY":
      return {
        ...state,
        BoatItemCategoryData: state?.BoatItemCategoryData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_BOAT_ITEM_CATEGORY":
      return {
        ...state,
        BoatItemCategoryData: state?.BoatItemCategoryData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_DINGHY_MAKE_STATIC_DATA":
      return {
        ...state,
        DinghyMakeData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.DinghyMakeData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_DINGHY_MAKE":
      return {
        ...state,
        DinghyMakeData: state?.DinghyMakeData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_DINGHY_MAKE":
      return {
        ...state,
        DinghyMakeData: state?.DinghyMakeData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_DINGHY_MAKE":
      return {
        ...state,
        DinghyMakeData: state?.DinghyMakeData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_SHIPPING_COMPANIES_STATIC_DATA":
      return {
        ...state,
        ShippingCompanyData:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.ShippingCompanyData, ...action?.payload?.data],
      };
    case "UPDATE_POSITION_SHIPPING_COMPANIES":
      return {
        ...state,
        ShippingCompanyData: state?.ShippingCompanyData?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_SHIPPING_COMPANIES":
      return {
        ...state,
        ShippingCompanyData: state?.ShippingCompanyData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "RESTORE_PERMENENT_DELETE_SHIPPING_COMPANIES":
      return {
        ...state,
        ShippingCompanyData: state?.ShippingCompanyData?.filter((elem: any) => elem?._id !== action?.payload),
      };

    default:
      return state;
  }
};
